var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(require('../../assets/image/public/nInfoMsgIsEmpty.png')),expression:"require('../../assets/image/public/nInfoMsgIsEmpty.png')"}],attrs:{"loading":"lazy","alt":""}}),_c('div',{staticClass:"nothingText"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }